module.exports = __webpack_public_path__ + "static/media/uts_logo.d1c4a144.svg";